import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router';
import ThemeToggle from '../common/ThemeToggle.jsx';
import styles from './Header.module.css';

const NAV_ITEMS = [
  { to: '/disciplines', label: 'Disciplines' },
  { to: '/blog', label: 'Blog' },
  { to: '/projects', label: 'Projects' },
  { to: '/events', label: 'Events' },
  { to: '/people', label: 'People' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile drawer upon route transition
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Close mobile drawer on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <header className={styles.header}>
      <div className={`container ${styles.inner}`}>
        <NavLink to="/" className={styles.brand} end aria-label="YACC Home">
          <img
            src="/logos/icon-circle.png"
            alt="YACC Icon"
            className={styles.logo}
            width={34}
            height={34}
          />
          <span className={styles.brandText}>YACC</span>
        </NavLink>

        <div className={styles.desktopControls}>
          <nav aria-label="Primary" className={styles.nav}>
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <ThemeToggle />
        </div>

        <div className={styles.mobileControls}>
          <ThemeToggle />
          <button
            type="button"
            className={`${styles.hamburger} ${menuOpen ? styles.hamburgerOpen : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={menuOpen}
          >
            <span className={styles.hamburgerBar} />
            <span className={styles.hamburgerBar} />
            <span className={styles.hamburgerBar} />
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      {menuOpen && (
        <div className={styles.drawerOverlay} onClick={() => setMenuOpen(false)}>
          <div
            className={styles.drawerContent}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Mobile Navigation"
          >
            <nav className={styles.mobileNav}>
              {NAV_ITEMS.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    isActive
                      ? `${styles.mobileNavLink} ${styles.mobileNavLinkActive}`
                      : styles.mobileNavLink
                  }
                  onClick={() => setMenuOpen(false)}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>

            <div className={styles.drawerFooter}>
              <p className="meta">Yet Another Coding Club (YACC)</p>
              <div className={styles.drawerSocials}>
                <a
                  href="https://linkedin.com/company/yacc-yet-another-coding-club"
                  target="_blank"
                  rel="noreferrer"
                >
                  LinkedIn
                </a>
                <a href="https://github.com/yacciitpkd" target="_blank" rel="noreferrer">
                  GitHub
                </a>
                <a href="https://instagram.com/yacc.iitpkd" target="_blank" rel="noreferrer">
                  Instagram
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
